import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleMatInward } from '../../../Store/PHPSlice/MatInward';

const TableBody = ({
    id,
    serialNumber,
    dt,
    inwardNo,
    materialNm,
    description,
    size,
    pkt,
    packetqty,
    totqty,
    qty,
    inwardqty,
    selected,
    handleClick,
}) => {

    const dispatch = useDispatch();
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/MaterialInwardEdit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        const isConfirmed = window.confirm("Are you sure you want to delete this Material Inward?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteSingleMatInward(id))
                .then(() => {
                    // Reload the page to show updated results
                    toast("Material Inward Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Material Inward:", error);
                    toast.error("Failed to delete Material Inward");
                });
        }
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{serialNumber}</TableCell>


                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{dt}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{inwardNo}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{materialNm}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{description}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {size}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {pkt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {packetqty}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {inwardqty}
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {qty}
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className="cursor-pointer" onClick={handleEditClick} />
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
            <ToastContainer />
        </>
    );
};

export default TableBody;
